<template>
  <div class="rs-news-ticker__tickercomponent" ref="component">
    <div
      ref="post"
      style="opacity: 0; visibility: hidden"
      class="rs-news-ticker__tickercomponent__post"
      v-for="(post, postIndex) in tickerDataArr"
      :key="post.id"
      :class="
        postIndex == currentPostIndex
          ? 'rs-news-ticker__tickercomponent__post__is-current'
          : 'rs-news-ticker__tickercomponent__post__is-not-current'
      "
    >
      <a
        :href="post.permalink"
        @mouseover="isPaused = true"
        @mouseout="isPaused = false"
        ><span class="rs-news-ticker__tickercomponent__post__title">{{
          post.post_title
        }}</span>
        <span class="rs-news-ticker__tickercomponent__post__arrow"
          >&nbsp;&gt;</span
        >
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "RSNewsTicker",
  components: {},
  props: {
    tickerData: String,
  },
  data() {
    return {
      tickerDataArr: [],
      currentPostIndex: 0,
      isPaused: false,
    };
  },
  watch: {},
  mounted: function () {
    this.tickerDataArr = JSON.parse(this.tickerData);
    setInterval(this.showNextPost, 6000);

    window.addEventListener("load", this.adjustComponentHeightToFitPosts);
    window.addEventListener("resize", this.adjustComponentHeightToFitPosts);
  },
  methods: {
    showNextPost() {
      if (!this.isPaused) {
        this.currentPostIndex++;
        this.currentPostIndex %= this.tickerDataArr.length;
      }
    },
    adjustComponentHeightToFitPosts() {
      let _minHeight = 0;
      this.$refs.post.forEach((postElement) => {
        let elementHeight = postElement.clientHeight;
        if (elementHeight && elementHeight > _minHeight)
          _minHeight = elementHeight;
      });
      this.$refs.component.style.minHeight = _minHeight + "px";
    },
  },
};
</script>
